import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => {
    const { color, radius, motion, mq } = theme.custom;
    return {
        dropZone: {
            minHeight: 320,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 6,
            padding: 24,
            textAlign: 'center',
            border: `2px dashed ${color.borderStrong}`,
            borderRadius: radius.lg,
            backgroundColor: color.surface,
            color: color.text.secondary,
            cursor: 'pointer',
            transitionProperty: 'border-color, background-color',
            transitionDuration: motion.base,
            '&:hover': { borderColor: color.primary.main },
            '&:focus-visible': { outline: `2px solid ${color.focusRing}`, outlineOffset: 2 },
            [mq.sm]: { minHeight: 220 },
        },
        dragging: { borderColor: color.primary.main, backgroundColor: color.primary.soft },
        dropIcon: {
            width: 48,
            height: 48,
            borderRadius: radius.md,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: color.primary.soft,
            color: color.primary.main,
            marginBottom: 6,
            '& svg': { fontSize: 26 },
        },
        dropTitle: { margin: 0, fontSize: 15, fontWeight: 600, color: color.text.primary },
        dropHint: { margin: 0, fontSize: 13 },
        processing: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12,
            minHeight: 240,
            color: color.text.secondary,
            fontSize: 14,
        },
        scroll: { overflowX: 'auto', maxHeight: 'calc(100vh - 300px)' },
        cell: { whiteSpace: 'nowrap', maxWidth: 320, overflow: 'hidden', textOverflow: 'ellipsis' },
    };
});
